<template>
  <div class="loading" v-show="isShow.isLDShow">
    <div class="animation">
      <div class="upper-element">
        <div class="person-m-wrapper" :style="{transform: 'translateX(' + humanTransX + 'px)', opacity: isRunningShow ? 1 : 0}" >
          <div class="person-m human-run"></div>
        </div>
        <div class="person-m-k" :class="isRunningShow ? '' : 'slideIn'" v-show="!isRunningShow"></div>
        <div class="person-f" :class="isRunningShow ? '' : 'slideIn'" v-show="!isRunningShow"></div>
      </div>
      <div class="carpet-wrapper">
        <div class="carpet"></div>
        <div class="carpet-holder" :style="{transform: 'translateX(' + transX + 'px)'}"></div>
      </div>
      <div class="ratio">{{ loadingNum }}%</div>
    </div>
    <div class="logo"></div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isShow: {
      type: Object
    }
  },
  data () {
    return {
      loadingNum: 0,
      imgArr: [],
      isRunningShow: true,
      preLoadImg: [
        { src: require('./logo.png') },
        { src: require('../page-kv/main-title.png') },
        { src: require('../page-kv/main-btn.png') },
        { src: require('../page-kv/main-bg.jpg') },
        { src: require('../page-one/img/bg1.jpg') },
        { src: require('../page-one/img/bg2.jpg') },
        { src: require('../page-one/img/bg3.jpg') },
        { src: require('../page-one/img/bg4.jpg') },
        { src: require('../page-one/img/bg5.jpg') },
        { src: require('../page-one/img/bg6.jpg') },
        { src: require('../page-one/img/bg7.jpg') },
        { src: require('../page-one/img/bg8.jpg') },
        { src: require('../page-one/img/bg9.jpg') },
        { src: require('../page-one/img/btn-generate.png') },
        { src: require('../page-one/img/btn-del.png') },
        { src: require('../page-one/img/btn-resize.png') },
        { src: require('../page-one/img/thumb-hm1.png') },
        { src: require('../page-one/img/thumb-hm2.png') },
        { src: require('../page-one/img/thumb-hm3.png') },
        { src: require('../page-one/img/thumb-hm4.png') },
        { src: require('../page-one/img/thumb-hm5.png') },
        { src: require('../page-one/img/thumb-hm6.png') },
        { src: require('../page-one/img/nav-arrow.png') },
        { src: require('../page-one/img/nav-dec.png') },
        { src: require('../page-one/img/nav-human.png') },
        { src: require('../page-one/img/nav-pet.png') },
        { src: require('../page-one/img/nav-place.png') },
        { src: require('../page-one/img/thumb-d1.png') },
        { src: require('../page-one/img/thumb-d2.png') },
        { src: require('../page-one/img/thumb-d3.png') },
        { src: require('../page-one/img/thumb-d4.png') },
        { src: require('../page-one/img/thumb-d5.png') },
        { src: require('../page-one/img/thumb-d6.png') },
        { src: require('../page-one/img/thumb-d7.png') },
        { src: require('../page-one/img/thumb-d8.png') },
        { src: require('../page-one/img/thumb-d9.png') },
        { src: require('../page-one/img/thumb-d10.png') },
        { src: require('../page-one/img/thumb-d11.png') },
        { src: require('../page-one/img/thumb-d12.png') },
        { src: require('../page-one/img/thumb-p1.png') },
        { src: require('../page-one/img/thumb-p2.png') },
        { src: require('../page-one/img/thumb-p3.png') },
        { src: require('../page-one/img/thumb-p4.png') },
        { src: require('../page-one/img/thumb-p5.png') },
        { src: require('../page-one/img/thumb-p6.png') },
        { src: require('../page-one/img/thumb-s1.jpg') },
        { src: require('../page-one/img/thumb-s2.jpg') },
        { src: require('../page-one/img/thumb-s3.jpg') },
        { src: require('../page-one/img/thumb-s4.jpg') },
        { src: require('../page-one/img/thumb-s5.jpg') },
        { src: require('../page-one/img/thumb-s6.jpg') },
        { src: require('../page-one/img/thumb-s7.jpg') },
        { src: require('../page-one/img/thumb-s8.jpg') },
        { src: require('../page-one/img/thumb-s9.jpg') },
        { src: require('../page-one/img/thumb-b-clothes1.png') },
        { src: require('../page-one/img/thumb-b-clothes2.png') },
        { src: require('../page-one/img/thumb-b-clothes3.png') },
        { src: require('../page-one/img/thumb-b-clothes4.png') },
        { src: require('../page-one/img/thumb-b-clothes5.png') },
        { src: require('../page-one/img/thumb-b-clothes6.png') },
        { src: require('../page-one/img/thumb-b-hair1.png') },
        { src: require('../page-one/img/thumb-b-hair2.png') },
        { src: require('../page-one/img/thumb-b-hair3.png') },
        { src: require('../page-one/img/thumb-b-hair4.png') },
        { src: require('../page-one/img/thumb-b-hair5.png') },
        { src: require('../page-one/img/thumb-b-hair6.png') },
        { src: require('../page-one/img/thumb-bg-clothes1.png') },
        { src: require('../page-one/img/thumb-bg-clothes2.png') },
        { src: require('../page-one/img/thumb-bg-clothes3.png') },
        { src: require('../page-one/img/thumb-bg-clothes4.png') },
        { src: require('../page-one/img/thumb-bg-clothes5.png') },
        { src: require('../page-one/img/thumb-bg-clothes6.png') },
        { src: require('../page-one/img/thumb-bg-hair1.png') },
        { src: require('../page-one/img/thumb-bg-hair2.png') },
        { src: require('../page-one/img/thumb-bg-hair3.png') },
        { src: require('../page-one/img/thumb-bg-hair4.png') },
        { src: require('../page-one/img/thumb-bg-hair5.png') },
        { src: require('../page-one/img/thumb-bg-hair6.png') },
        { src: require('../page-one/img/thumb-bm1.png') },
        { src: require('../page-one/img/thumb-bm2.png') },
        { src: require('../page-one/img/thumb-bm3.png') },
        { src: require('../page-one/img/thumb-bmm1.png') },
        { src: require('../page-one/img/thumb-bmm2.png') },
        { src: require('../page-one/img/thumb-bmm3.png') },
        { src: require('../page-one/img/thumb-chf1.png') },
        { src: require('../page-one/img/thumb-chf2.png') },
        { src: require('../page-one/img/thumb-chf3.png') },
        { src: require('../page-one/img/thumb-chm1.png') },
        { src: require('../page-one/img/thumb-chm1.png') },
        { src: require('../page-one/img/thumb-chm1.png') },
        { src: require('../page-one/img/bg1.jpg') },
        { src: require('../page-one/img/bg2.jpg') },
        { src: require('../page-one/img/bg3.jpg') },
        { src: require('../page-one/img/bg4.jpg') },
        { src: require('../page-one/img/bg5.jpg') },
        { src: require('../page-one/img/bg6.jpg') },
        { src: require('../page-one/img/bg7.jpg') },
        { src: require('../page-one/img/bg8.jpg') },
        { src: require('../page-one/img/bg9.jpg') },
        { src: require('../page-one/img/dec1.png') },
        { src: require('../page-one/img/dec2.png') },
        { src: require('../page-one/img/dec3.png') },
        { src: require('../page-one/img/dec4.png') },
        { src: require('../page-one/img/dec5.png') },
        { src: require('../page-one/img/dec6.png') },
        { src: require('../page-one/img/dec7.png') },
        { src: require('../page-one/img/dec8.png') },
        { src: require('../page-one/img/dec9.png') },
        { src: require('../page-one/img/dec10.png') },
        { src: require('../page-one/img/dec11.png') },
        { src: require('../page-one/img/dec12.png') },
        { src: require('../page-one/img/pet1.png') },
        { src: require('../page-one/img/pet2.png') },
        { src: require('../page-one/img/pet3.png') },
        { src: require('../page-one/img/pet4.png') },
        { src: require('../page-one/img/pet5.png') },
        { src: require('../page-one/img/pet6.png') },
        { src: require('../page-two/img/btn-l.png') },
        { src: require('../page-two/img/btn-r.png') },
        { src: require('../page-two/img/fn-b-flower.png') },
        { src: require('../page-two/img/fn-cloth.png') },
        { src: require('../page-two/img/fn-sepr-flower.png') },
        { src: require('../page-two/img/fn-up-mask.png') },
        { src: require('../page-trans/cloud1.png') },
        { src: require('../page-trans/cloud2.png') },
        { src: require('../page-trans/trans-bg.jpg') }
      ]
    }
  },
  computed: {
    transX() {
      return 3.02 * this.loadingNum;
    },
    humanTransX() {
      return 1.4 * this.loadingNum;
    }
  },
  methods: {
    generateId (index) {
      return 'mImg' + index
    },
    go () {
      this.isShow.isLDShow = false
      this.isShow.isKVShow = true
    },
    loadNextImg(imgID){
      const _this = this
      const len = this.preLoadImg.length
      const curSrc = this.preLoadImg[imgID].src
      let curImg = new Image()
      curImg.onload = function () {
        imgID++
        _this.loadingNum = parseInt(imgID / len * 100)
        if (imgID < len) {
          _this.loadNextImg(imgID)
        } else {
          _this.isRunningShow = false;
          setTimeout(() => {
            _this.go();
          }, 600)

        }
      }
      curImg.src = curSrc
    }
  },
  mounted () {
    let imgID = 0
    setTimeout(() => {
      this.loadNextImg(imgID)
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
.loading {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  .animation {
    position: relative;
    margin-bottom: 5rem /* 80/16 */;
    .upper-element {
      position: relative;
      margin-bottom: -.5rem /* 8/16 */;
      z-index: 2;
      .person-m-wrapper {
        .person-m {
          display: inline-block;
          width: 67.5px;
          height: 106px;
          background-size: cover;
          background-repeat: no-repeat;
          background-image: url(./run.png);
        }
      }
      .person-m-k {
        position: absolute;
        bottom: 0;
        right: 4.375rem /* 70/16 */;
        width: 4.5rem /* 72/16 */;
        height: 5.3125rem /* 85/16 */;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url(./knock-human.png);
      }
      .person-f {
        position: absolute;
        right: 1.25rem /* 20/16 */;
        bottom: 0;
        display: inline-block;
        width: 3.96875rem /* 63.5/16 */;
        height: 6.3125rem /* 101/16 */;
        background-image: url(./girl.png);
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
    .carpet-wrapper {
      position: relative;
      overflow: hidden;
      width: 18.875rem /* 302/16 */;
      height: .96875rem /* 15.5/16 */;
      .carpet {
        position: absolute;
        width: 18.875rem /* 302/16 */;
        height: .96875rem /* 15.5/16 */;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url(./carpet.png);
      }
      .carpet-holder {
        position: absolute;
        width: 18.875rem /* 302/16 */;
        height: .96875rem /* 15.5/16 */;
        background-color: #fff;
      }
    }
    .ratio {
      margin-top: 1.25rem /* 20/16 */;
      text-align: center;
      color: #333;
      font-size: .875rem /* 14/16 */;
    }
  }
  .logo {
    position: absolute;
    left: 50%;
    bottom: 12vh;
    transform: translateX(-3.90625rem /* 62.5/16 */);
    width: 7.8125rem /* 125/16 */;
    height: .875rem /* 14/16 */;
    background-image: url(./logo.png);
    background-size: 100% 100%;
  }
}

.human-run {
  animation: run steps(1, end) .6s infinite;
}

@keyframes run {
  0% {
    background-position: 0 0;
  }
  25% {
    background-position: -67.5px 0;
  }
  50% {
    background-position: -135px 0;
  }
  75% {
    background-position: -202.5px 0;
  }
  100% {
    background-position: -270px 0;
  }
}

.slideIn {
  animation: slideIn .01s ease-in;
  animation-fill-mode: both;
}

@keyframes slideIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
